import { styled } from '@mui/material/styles';

export const Detail = styled('div')(({ theme, size }) => ({
  borderLeft: `1px solid ${theme.color.grey[500]}`,
  paddingLeft: theme.spacing(1),
  marginRight: theme.spacing(1),
  padding: theme.spacing(0, 1, 0, 1),
  ...(size && { flex: `1 1 ${size}` }),
  '@media (max-width: 500px)': {
    borderBottom: `1px solid ${theme.color.grey[500]}`
  }
}));

export const DetailLabel = styled('div')(({ theme }) => ({
  fontSize: theme.fontSize.xsmall,
  margin: `${theme.spacing(0.5)} 0`,
  textTransform: 'uppercase'
}));

export const DetailValue = styled('div')(({ theme, $black, $nowrap }) => ({
  color: $black ? theme.color.text.main : theme.color.primary.main,
  fontWeight: theme.fontWeight.bold,
  margin: `${theme.spacing(1)} 0`,
  ...($nowrap && { whiteSpace: 'nowrap' })
}));

export const DetailLinkValue = styled('a')(({ theme, $black }) => ({
  color: $black ? theme.color.text.main : theme.color.primary.main,
  fontWeight: theme.fontWeight.bold,
  margin: `${theme.spacing(1)} 0`,
  textDecoration: 'none'
}));
